import { Routes, Route } from "react-router-dom";

import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import FAQs from "./components/FAQs";
import Employment from "./components/Employment";
import ContactUs from "./components/ContactUs";
import ThankYouPage from "./components/ThankYouPage";

import "./App.css";

const App = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/about-us" element={<AboutUs />} />
    <Route path="/faqs" element={<FAQs />} />
    <Route path="/employment" element={<Employment />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/thank-you" element={<ThankYouPage />} />
  </Routes>
);

export default App;
